// extracted by mini-css-extract-plugin
export default {"token_amount":"LimitCurrencyQuantity_token_amount__5FH7X","currency_quantity":"LimitCurrencyQuantity_currency_quantity__fLPNt"};